module.exports = __webpack_public_path__ + "img/5备份 2.e8a37e91.jpg";